import { render, staticRenderFns } from "./TableHeatmapGraph.vue?vue&type=template&id=20dba9cd&scoped=true&"
import script from "./TableHeatmapGraph.vue?vue&type=script&lang=js&"
export * from "./TableHeatmapGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dba9cd",
  null
  
)

export default component.exports